// Frame2 - chọn game: đổi active + đổi ảnh bg (PC + mobile) có zoom + gắn link vào nút
$(function () {
	var $items = $('#Frame2 .list-game > li');
	var $bgPc = $('#Frame2 .background .bg.MS__pc');
	var $bgMb = $('#Frame2 .background .bg.MS__mb');
	var $btn = $('#Frame2 .btn-chuyendoi');
	var basePath = 'https://cdn-mainsite-aka.vnggames.com/products/bomber/2026-hub/dist/optimized/Frame2/images/bg-';

	// Preload trước các ảnh (PC + mobile) để lúc đổi không bị giật
	for (var n = 1; n <= $items.length; n++) {
		new Image().src = basePath + n + '.jpg';
		new Image().src = basePath + n + '-mb.jpg';
	}

	// Gắn link của item vào nút chuyển đổi
	function applyLink($li) {
		$btn.attr('href', $li.find('a').attr('data-link') || '#');
	}

	// Đổi ảnh + retrigger animation zoom cho 1 thẻ bg
	// set cả data-src để lazyload (nếu chạy sau) không ghi đè về ảnh cũ
	function swapBg($img, src) {
		if (!$img.length) return;
		$img.attr('src', src).attr('data-src', src);
		$img.removeClass('bg-zoom');
		void $img[0].offsetWidth;
		$img.addClass('bg-zoom');
	}

	$items.on('click', function () {
		var idx = $items.index(this) + 1; // 1..5

		$items.removeClass('active');
		$(this).addClass('active');

		// gắn link trước (luôn chạy), rồi đổi ảnh cho cả PC + mobile
		applyLink($(this));
		swapBg($bgPc, basePath + idx + '.jpg');
		swapBg($bgMb, basePath + idx + '-mb.jpg');
	});

	// Khởi tạo theo item đang active (mặc định nav-1 + bg-1)
	applyLink($items.filter('.active').first());

	// Khi user cuộn tới Frame2 -> thêm .in-view để title trượt vào (chạy 1 lần)
	var f2 = document.getElementById('Frame2');
	if (f2) {
		if ('IntersectionObserver' in window) {
			var io = new IntersectionObserver(function (entries) {
				entries.forEach(function (e) {
					if (e.isIntersecting) {
						f2.classList.add('in-view');
						io.disconnect();
					}
				});
			}, { threshold: 0.15 });
			io.observe(f2);
		} else {
			f2.classList.add('in-view'); // fallback trình duyệt cũ
		}
	}
});
